import {
  LayoutDashboard,
  ClipboardList,
  Boxes,
  Package,
  BadgePercent,
  Users,
  BarChart3,
  ScrollText,
  Settings,
  Ticket,
  Gift,
  Gem,
  Store,
  UserCog,
  type LucideIcon,
} from 'lucide-react';
import type { Permission } from '@hutdrop/shared';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission: Permission;
  /** Roadmap phase that builds this screen (shown until it ships). */
  phase: number;
  description: string;
}

/** Staff navigation. Items are hidden when the signed-in role lacks the permission. */
export const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, permission: 'orders.view', phase: 16, description: 'Store overview: orders waiting, expiring holds, low stock and active deals.' },
  { to: '/orders', label: 'Orders', icon: ClipboardList, permission: 'orders.view', phase: 13, description: 'New, ready, expiring and completed pre-orders, QR scanning and pickup completion.' },
  { to: '/inventory', label: 'Inventory', icon: Boxes, permission: 'products.view', phase: 2, description: 'Stock levels, receiving, adjustments with reasons, and inventory history.' },
  { to: '/products', label: 'Products', icon: Package, permission: 'products.view', phase: 2, description: 'Catalog, categories, brands, pricing and product photos.' },
  { to: '/promotions', label: 'Deals & Specials', icon: BadgePercent, permission: 'promotions.manage', phase: 6, description: "Deals, today's specials, flash deals and digital coupons." },
  { to: '/coupons', label: 'Coupons', icon: Ticket, permission: 'promotions.manage', phase: 8, description: 'Digital coupons customers save and apply in their cart.' },
  { to: '/vip', label: 'VIP access', icon: Gem, permission: 'vip.manage', phase: 31, description: 'PINs for VIP members, who can see VIP-only products.' },
  { to: '/rewards', label: 'Rewards', icon: Gift, permission: 'promotions.manage', phase: 30, description: 'Points, rewards, drops and customer point adjustments.' },
  { to: '/customers', label: 'Customers', icon: Users, permission: 'customers.view', phase: 13, description: 'Customer accounts and their pre-order history.' },
  { to: '/reports', label: 'Reports', icon: BarChart3, permission: 'reports.view', phase: 17, description: 'Orders, inventory, product and promotion performance.' },
  { to: '/store', label: 'Store info', icon: Store, permission: 'store.hours', phase: 14, description: 'Address, phone, hours and holiday closures.' },
  { to: '/audit', label: 'Audit log', icon: ScrollText, permission: 'audit.view', phase: 1, description: 'Every important staff and system action.' },
  { to: '/staff', label: 'Staff', icon: UserCog, permission: 'staff.manage', phase: 27, description: 'Staff accounts, roles and passwords.' },
  { to: '/settings', label: 'Settings', icon: Settings, permission: 'settings.manage', phase: 14, description: 'Store details, hours, pickup rules and staff accounts.' },
];
